import {ApiClient} from '@hconnect/apiclient'
import type {User} from '@hconnect/common/types'
import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {HrocChecklistsQueryKey} from '../../types'

const CACHE_TIME_IN_MS = 1000 * 60

export const useSupervisorUserSearch = (
  plantId: string,
  namePattern: string | undefined,
  options?: Omit<UseQueryOptions<User[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const path = `/hroc-checklists/api/${plantId}/users/supervisors`

  return useQuery<User[], AxiosError>({
    queryKey: [HrocChecklistsQueryKey.SupervisorUserSearch, namePattern, plantId],
    queryFn: async ({signal}) => {
      if (!namePattern) {
        return Promise.resolve([])
      }
      const response = await ApiClient.axiosInstance.get<User[]>(path, {
        params: {namePattern},
        signal
      })
      return response.data
    },
    gcTime: CACHE_TIME_IN_MS,
    refetchOnWindowFocus: false,
    ...options
  })
}
